import { AfterViewInit, Component, DestroyRef, inject, signal, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, EMPTY } from 'rxjs';
import { Tab } from 'bootstrap';
import { ShowComponent } from 'src/app/common/component/show.component';
import { AuthService } from 'src/app/auth/auth.service';
import { Permissions } from '@/common/enums/Permissions';
import { Driver } from './driver.model';
import { DriversRateSetComponent } from './drivers-salary-common/drivers-rate-set/drivers-rate-set.component';
import { DriversSalaryDaysListComponent } from './drivers-salary-common/drivers-salary-days-list/drivers-salary-days-list.component';
import { DriversSalarySummaryMonthComponent } from './drivers-salary-common/drivers-salary-summary-month/drivers-salary-summary-month.component';
import { DriversSalaryPaymentsComponent } from './drivers-salary-common/drivers-salary-summary-month/drivers-salary-payments/drivers-salary-payments.component';
import { DateService } from '../common/date.service';
import { DriversDietSetComponent } from './drivers-salary-common/drivers-diet-set/drivers-diet-set.component';
import { DriversSalaryV2StateService } from './drivers-salary-v2/_services/drivers-salary-v2.state.service';
import { DriversIntegrationApiService } from './drivers-integration/_api/drivers-integration.api.service';
import { GratyfikantMapping } from './drivers-integration/_models/drivers-integration.model';

@Component({
	selector: 'app-drivers',
	templateUrl: './drivers.component.html',
	styleUrls: ['./drivers.component.css'],
	providers: [DriversSalaryV2StateService],
})
export class DriversComponent extends ShowComponent implements AfterViewInit {
	@ViewChild(DriversSalaryDaysListComponent)
	DriversSalaryDaysListComponent: DriversSalaryDaysListComponent;
	@ViewChild(DriversSalarySummaryMonthComponent)
	DriversSalarySummaryMonthComponent: DriversSalarySummaryMonthComponent;
	@ViewChild(DriversRateSetComponent)
	DriversRateSetComponent: DriversRateSetComponent;
	@ViewChild(DriversDietSetComponent)
	DriversDietSetComponent: DriversDietSetComponent;
	@ViewChild(DriversSalaryPaymentsComponent)
	DriversSalaryPaymentsComponent: DriversSalaryPaymentsComponent;
	protected itemsBeforeDataLoad = 3;
	protected parentComponent = 'drivers';
	readonly auth = inject(AuthService);
	protected readonly Permissions = Permissions;
	private readonly destroyRef = inject(DestroyRef);
	private readonly integrationApi = inject(DriversIntegrationApiService);
	readonly employmentPeriod = signal<GratyfikantMapping | null>(null);

	data: Driver = {
		id: null,
		first_name: null,
		last_name: null,
		status: null,
		birthdate: null,
		phone_private: null,
		phone_business: null,
		email_private: null,
		email_business: null,
		nearest_city: null,
		rate: null,
		chronically_ill: null,
		comments: null,
		vaccinations: 0,
		whenContact: null,
		salary: null,
		workTax: null,
		breakTax: null,
		otherTax: null,
		driverKinds: null,
		diet_cash: 0,
		different_account_diet: 0,
		companyId: null,
		bankaccount: null,
		name: null,
		documents: {
			trailer: {
				id: null,
				date: null,
				kind: null,
				checkDocument: null,
			},
			driverLicense: {
				id: null,
				date: null,
				kind: null,
				checkDocument: null,
			},
			qualification: {
				id: null,
				date: null,
				kind: null,
				checkDocument: null,
			},
			driverCard: {
				id: null,
				date: null,
				kind: null,
				checkDocument: null,
			},
			passport: {
				id: null,
				date: null,
				kind: null,
				checkDocument: null,
			},
			idCard: {
				id: null,
				date: null,
				kind: null,
				checkDocument: null,
			},
			medicalCheckUp: {
				id: null,
				date: null,
				kind: null,
				checkDocument: null,
			},
			psychologyCheckUp: {
				id: null,
				date: null,
				kind: null,
				checkDocument: null,
			},
			foreigner: {
				id: null,
				date: null,
				kind: null,
				checkDocument: null,
			},
			workPermit: {
				id: null,
				date: null,
				kind: null,
				checkDocument: null,
			},
			eta: {
				id: null,
				date: null,
				kind: null,
				checkDocument: null,
			},
		},
	};

	validationDate;
	driverData: any;
	bonusData: any;
	confirmedHistory: any;
	salaryData: any;
	cities: Array<any> = [];
	statuses: Array<any> = [];
	selectedMonth = null;
	selectedAction = 'driver';
	errors = {};
	driverKinds;
	companies: Array<any> = [];
	private readonly tabNames = [
		'basic',
		'documents',
		'other',
		'rates',
		'salary',
		'summary',
		'salaryV2',
		'history',
		'ledger',
		'integration',
		'scannedDocuments',
	];
	private readonly tabAnchors = [
		'podstawowe',
		'documents',
		'other',
		'stawki',
		'salaryDays',
		'summary',
		'salaryV2',
		'salary-confirm-history',
		'expenses',
		'integracje',
		'scanned-documents',
	];
	private readonly tabActionMap: Record<string, string> = {
		basic: 'driver',
		documents: 'driver',
		other: 'driver',
		rates: 'rate',
		salary: 'salary',
		summary: 'summary',
		salaryV2: 'salaryV2',
		history: 'history',
		ledger: 'expenses',
		integration: 'driver',
		scannedDocuments: 'driver',
	};
	private initialTab: string | null = null;
	showScannedDocuments = false;
	yesno: Array<any> = [
		{ id: 0, name: 'Brak danych' },
		{ id: 1, name: 'Tak' },
		{ id: 2, name: 'Nie' },
	];

	override ngOnInit(): void {
		super.ngOnInit();
		this.loadEmploymentPeriod();
		this.route.queryParams.subscribe((params) => {
			const tabParam = params['tab'] === 'expenses' ? 'ledger' : params['tab'];
			if (tabParam && this.tabNames.includes(tabParam)) {
				this.initialTab = tabParam;
				this.activateTab(tabParam);
			}
			const monthParam = params['selectedMonth'];
			if (monthParam && /^\d{4}-(0[1-9]|1[0-2])$/.test(monthParam)) {
				this.selectedMonth = monthParam;
			}
		});
	}

	ngAfterViewInit(): void {
		if (this.initialTab) {
			setTimeout(() => this.activateTab(this.initialTab), 0);
		}
	}

	protected loadBefore() {
		this.api.get('/nearestBigCity/', (result, error) => {
			this.cities = result.data;
			this.loadData();
		});
		this.api.get('/driverStatus/', (result, error) => {
			this.statuses = result.data;
			this.loadData();
		});
		this.api.get('/company/', (result, error) => {
			this.companies = result.data;
			this.loadData();
		});
		this.api.get('/driverKinds/', (result, error) => {
			this.driverKinds = result.data;
			this.loadData();
		});
		const date = new DateService();
		this.validationDate = date.daysAdd(31, date.now().date);
	}

	canOpenTab(tabName: string): boolean {
		if (tabName !== 'salaryV2') {
			return true;
		}
		return !!this.auth.permissionsByCode()[Permissions.FINANCIAL_SETTLEMENTS_ACCESS];
	}

	setTab(tabName: string, action: string) {
		if (!this.canOpenTab(tabName)) {
			return;
		}
		this.selectedAction = action;
		if (tabName === 'scannedDocuments') {
			this.showScannedDocuments = true;
		}
		this.router.navigate([], {
			relativeTo: this.route,
			queryParams: { tab: tabName === 'basic' ? null : tabName },
			queryParamsHandling: 'merge',
		});
	}

	private loadEmploymentPeriod(): void {
		if (this.pageFunction !== 'edit' || !this.data.id) {
			return;
		}
		this.integrationApi
			.getGratyfikant(this.data.id)
			.pipe(
				catchError(() => EMPTY),
				takeUntilDestroyed(this.destroyRef),
			)
			.subscribe((result) => this.employmentPeriod.set(result.data[0] ?? null));
	}

	private activateTab(tabName: string): void {
		const tabIndex = this.tabNames.indexOf(tabName);
		if (tabIndex === -1) return;
		if (!this.canOpenTab(tabName)) return;
		this.selectedAction = this.tabActionMap[tabName];
		if (tabName === 'scannedDocuments') {
			this.showScannedDocuments = true;
		}
		const anchor = this.tabAnchors[tabIndex];
		const tabEl = document.querySelector(`a[href="#${anchor}"]`);
		if (tabEl) {
			new Tab(tabEl).show();
		}
	}

	setMonth(day: string) {
		this.selectedMonth = day;
		this.router.navigate([], {
			relativeTo: this.route,
			queryParams: { selectedMonth: day || null },
			queryParamsHandling: 'merge',
		});
	}

	getDriverData($event) {
		this.driverData = $event;
	}

	getBonusData($event) {
		this.bonusData = $event;
	}

	getSalaryBasicData($event) {
		this.salaryData = $event;
	}

	getConfirmedHistory($event) {
		this.confirmedHistory = $event;
	}

	sendData() {
		switch (this.selectedAction) {
			case 'driver':
				if (!this.data.documents.idCard.date && this.data.documents.passport.date) {
					this.data.documents.passport.checkDocument = '1';
					this.data.documents.idCard.checkDocument = '2';
				} else if (!this.data.documents.passport.date && this.data.documents.idCard.date) {
					this.data.documents.passport.checkDocument = '2';
					this.data.documents.idCard.checkDocument = '1';
				} else {
					this.data.documents.passport.checkDocument = '1';
					this.data.documents.idCard.checkDocument = '1';
				}
				this.data.documents.workPermit.checkDocument = this.data.documents.foreigner.checkDocument;
				this.submit();
				break;
			case 'salary':
				this.DriversSalaryDaysListComponent.submit();
				this.editable = false;
				break;
			case 'summary':
				this.DriversSalarySummaryMonthComponent.submit();
				this.editable = false;
				break;
		}
	}

	protected clearDate(type: string) {
		switch (type) {
			case 'isForeigner':
				if (this.data.documents.foreigner.checkDocument !== '1') {
					this.data.documents.foreigner.date = null;
					this.data.documents.workPermit.date = null;
				}
				break;
			case 'trailer':
				if (this.data.documents.trailer.checkDocument !== '1') {
					this.data.documents.trailer.date = null;
				}
				break;
		}
	}

	protected infoChangeWages() {
		if (this.pageFunction !== 'add') {
			this.infobox.warning(
				'<h4>UWAGA</h4>Zmieniasz status kierowcy, </br>upewnij się że jego stawka jest zgodna',
			);
		}
	}

	rateSetModalOpen() {
		this.DriversRateSetComponent.openModal();
	}

	protected convertData(data) {
		data.diet_cash = data.diet_cash == 1 ? true : false;
		data.different_account_diet = data.different_account_diet == 1 ? true : false;
		for (const key in this.data.documents) {
			if (!data.documents[key]) {
				if (key == 'trailer' || key == 'foreigner' || key == 'workPermit') {
					data.documents[key] = {
						id: null,
						date: null,
						checkDocument: 2,
					};
					continue;
				}
				data.documents[key] = {
					id: null,
					date: null,
					checkDocument: null,
				};
			}
		}
		return data;
	}
}
